import ProgressBar from './ProgressBar';

export default ProgressBar;
